<script>export let currency = "GBP";
let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone; // Europe/London 

let language = navigator.language; //en-GB = uk, en-US = usa, 

let suggest = "";
let basket, forceitem;
let symbols = {
  "GBP": "£",
  "USD": "$",
  "EUR": "€"
};

async function load() {
  var _await$res$json, _basket, _basket$items;

  let res = await fetch(`/duocms/api/basket`);
  basket = (_await$res$json = await res.json()) === null || _await$res$json === void 0 ? void 0 : _await$res$json.data;
  console.log({
    basket
  });
  forceitem = (_basket = basket) === null || _basket === void 0 ? void 0 : (_basket$items = _basket.items) === null || _basket$items === void 0 ? void 0 : _basket$items.find(item => item.force_currency);

  if (forceitem && forceitem.currency != currency) {
    setCurrency(forceitem.currency);
  }
}

async function setCurrency(code) {
  await fetch(`/duocms/api/basket?currency=${code}`);
  window.location.reload();
}

if (language == "en-GB" && timezone.match(/london/i) && currency != "GBP") {
  suggest = "GBP";
}

if (!timezone.match(/london/i) && timezone.match(/europe/i) && currency != "EUR") {
  suggest = "EUR";
}

if (language == "en-US" && timezone.match(/america/i) && currency != "USD") {
  suggest = "USD";
}

load();</script>

{#if suggest && !forceitem}
  <div class="alert alert-warning">
    {#if suggest=="GBP"}
      <p>Your currency is currently set to {symbols[currency]}({currency}), but you appear to be purchasing from a UK timezone</p>
      <br>
      <button class="btn btn-warning btn-sm" on:click={()=> setCurrency("GBP")}> Click here to use £(GBP)</button>
    {/if}

    {#if suggest=="EUR"}
      <p>Your currency is currently set to {symbols[currency]}({currency}), but you appear to be purchasing from a European Country</p>
      <button class="btn btn-warning btn-sm" on:click={()=> setCurrency("EUR")}> Click here to use €(EUR)</button>
    {/if}

    {#if suggest=="USD"}
      <p>Your currency is currently set to {symbols[currency]}({currency}), but you appear to be purchasing from a US timezone</p>
      <button class="btn btn-warning btn-sm" on:click={()=> setCurrency("USD")}> Click here to use $(USD)</button>
    {/if}
  </div>
{/if}

{#if forceitem}
    <div class="alert alert-warning">
      <p>Due to purchasing <strong>"{forceitem.name}"</strong>, your currency has been set to {symbols[forceitem.currency]} as this product can only be purchased in that currency.</p>
    </div>
{/if}